export const URLS = {
  userSignUp: '/api/users/sign-up',

  login: '/api/oauth/token',
  /** Keycloak JSON login — returns slim token payload only; hydrate profile via {@link userContext}. */
  keycloakLogin: '/api/auth/token',
  keycloakRefreshToken: '/authenticated/refresh-token',
  userContext: '/authenticated/user-context',
  logout: '/authenticated/user/logout',

  resendVerificationCode: '/api/users/resend-code',
  verifyVerificationCode: 'api/users/verify-email',
  forgotPassword: '/api/users/forgot-password',
  resetForgottenPassword: '/api/users/password',

  getTheme: `/api/organizations/theme`,
  getCustomerTranslations: (languageCode: string) => `/api/customer-translations/${languageCode}`,
  getInitialData: '/api/organizations/initial-data',
  getTermsAndConditions: '/api/terms-conditions',
  getSliderImages: '/api/parent-organization/slider-images',

  getLocations: '/api/locations',
  getEventTypes: '/api/event-types',
  getTimeSlotsForEvent: (id: any) => `/api/event-type/${id}/timeslots`,
  getSearchedOrganizations: '/api/organizations',
  getAvailableVenues: (id: any) => `/api/organizations/${id}/available-venues`,
  getAvailableVenuesCalendar: (id: any) => `/api/organizations/${id}/available-venues/calendar`,
  getRoomTypes: (id: any) => `/api/organizations/${id}/room-types`,
  getEventTypeById: (id: any) => `/api/event-types/${id}`,
  getTimeSlotById: (id: any) => `/api/timeslots/${id}`,
  getPricePackageById: (id: any) => `/api/price-packages/${id}`,
  getLanguages: '/api/languages',
  getCountries: 'api/countries',
  getStates: (selectedCountry: any) => `api/countries/${selectedCountry}/states`,
  getCities: (selectedState: any) => `api/states/${selectedState}/cities`,
  getMealPlanConfigs: (orgId: any, id: any) => `/api/organizations/${orgId}/room-types/${id}/meal-plans`,

  getBookingsForCurrentUser: '/authenticated/currentuser/bookings/page',
  getCostingDetails: (orgId: any) => `/api/organizations/${orgId}/costing`,
  getCostingDetailsById: (id: any) => `/authenticated/bookings/${id}/costing`,
  getBookingSummary: '/api/bookings/summary',
  getBookingSummaryById: (id: any) => `/api/bookings/${id}/summary`,
  getPaymentSummary: '/authenticated/bookings/summary',
  getPaymentSummaryById: (id: any) => `/authenticated/bookings/${id}/summary`,
  raiseCancelOrEditBookingRequest: (id: any) => `/authenticated/user/booking-items/${id}/status`,
  updateBookingStatus: (id: any) => `/authenticated/bookings/${id}/status`,
  updateBookingStatusEmbedded: (id: any) => `/api/bookings/${id}/status`,

  submitRfq: '/api/request-for-quote',

  getLoggedInUserDetails: '/authenticated/users/me',
  updateUserProfile: (id: any) => `/authenticated/user/${id}/update-profile`,
  updateUserEmail: '/authenticated/user/update-email',
  changePassword: '/authenticated/users/change-password',
};
